export const RiskMatrixVariants = {
  "5x5": {
    matrix: [
      [
        { impact: 1, likelihood: 5, value: 5, score: "moderate" },
        { impact: 2, likelihood: 5, value: 10, score: "major" },
        { impact: 3, likelihood: 5, value: 15, score: "major" },
        { impact: 4, likelihood: 5, value: 20, score: "critical" },
        { impact: 5, likelihood: 5, value: 25, score: "critical" },
      ],
      [
        { impact: 1, likelihood: 4, value: 4, score: "moderate" },
        { impact: 2, likelihood: 4, value: 8, score: "moderate" },
        { impact: 3, likelihood: 4, value: 12, score: "major" },
        { impact: 4, likelihood: 4, value: 16, score: "major" },
        { impact: 5, likelihood: 4, value: 20, score: "critical" },
      ],
      [
        { impact: 1, likelihood: 3, value: 3, score: "minor" },
        { impact: 2, likelihood: 3, value: 6, score: "moderate" },
        { impact: 3, likelihood: 3, value: 9, score: "moderate" },
        { impact: 4, likelihood: 3, value: 12, score: "major" },
        { impact: 5, likelihood: 3, value: 15, score: "major" },
      ],
      [
        { impact: 1, likelihood: 2, value: 2, score: "minor" },
        { impact: 2, likelihood: 2, value: 4, score: "minor" },
        { impact: 3, likelihood: 2, value: 6, score: "moderate" },
        { impact: 4, likelihood: 2, value: 8, score: "moderate" },
        { impact: 5, likelihood: 2, value: 10, score: "major" },
      ],
      [
        { impact: 1, likelihood: 1, value: 1, score: "minor" },
        { impact: 2, likelihood: 1, value: 2, score: "minor" },
        { impact: 3, likelihood: 1, value: 3, score: "minor" },
        { impact: 4, likelihood: 1, value: 4, score: "moderate" },
        { impact: 5, likelihood: 1, value: 5, score: "moderate" },
      ],
    ],
  },
  "5x5-alt1": {
    matrix: [
      [
        { impact: 1, likelihood: 5, value: 5, score: "minor" },
        { impact: 2, likelihood: 5, value: 10, score: "major" },
        { impact: 3, likelihood: 5, value: 15, score: "major" },
        { impact: 4, likelihood: 5, value: 20, score: "critical" },
        { impact: 5, likelihood: 5, value: 25, score: "critical" },
      ],
      [
        { impact: 1, likelihood: 4, value: 4, score: "minor" },
        { impact: 2, likelihood: 4, value: 8, score: "moderate" },
        { impact: 3, likelihood: 4, value: 12, score: "major" },
        { impact: 4, likelihood: 4, value: 16, score: "major" },
        { impact: 5, likelihood: 4, value: 20, score: "critical" },
      ],
      [
        { impact: 1, likelihood: 3, value: 3, score: "minor" },
        { impact: 2, likelihood: 3, value: 6, score: "moderate" },
        { impact: 3, likelihood: 3, value: 9, score: "moderate" },
        { impact: 4, likelihood: 3, value: 12, score: "major" },
        { impact: 5, likelihood: 3, value: 15, score: "major" },
      ],
      [
        { impact: 1, likelihood: 2, value: 2, score: "minor" },
        { impact: 2, likelihood: 2, value: 4, score: "minor" },
        { impact: 3, likelihood: 2, value: 6, score: "moderate" },
        { impact: 4, likelihood: 2, value: 8, score: "moderate" },
        { impact: 5, likelihood: 2, value: 10, score: "major" },
      ],
      [
        { impact: 1, likelihood: 1, value: 1, score: "minor" },
        { impact: 2, likelihood: 1, value: 2, score: "minor" },
        { impact: 3, likelihood: 1, value: 3, score: "minor" },
        { impact: 4, likelihood: 1, value: 4, score: "minor" },
        { impact: 5, likelihood: 1, value: 5, score: "minor" },
      ],
    ],
  },
};

export const RiskScoreNone = { impact: 0, likelihood: 0, value: 0, score: "none" };
